export default __webpack_public_path__ + "static/media/manage_team_settings.68dd388a.png";